interface EntryPathParams {
  /**
   * Para onde o bloco manda os cards dele — o caminho da listagem, já
   * interpolado. É a configuração do próprio bloco: sem ela não há como saber
   * sob qual rota o registro mora.
   */
  listingLink?: string | null;
  /** Slug do registro. Ausente, o caminho para na listagem. */
  itemSlug?: string | null;
}

interface EntryUrlParams extends EntryPathParams {
  /** Origem já resolvida pelo `buildSiteBaseUrl`, com o prefixo do canal. */
  baseUrl?: string | null;
}

function normalize(listingLink?: string | null): string | null {
  const trimmed = listingLink?.trim();
  if (!trimmed) return null;

  const withoutTrailing = trimmed.replace(/\/+$/, "");
  if (withoutTrailing.length === 0) return null;

  return withoutTrailing.startsWith("/")
    ? withoutTrailing
    : `/${withoutTrailing}`;
}

/**
 * Caminho do registro dentro do site, **sem** o prefixo do canal.
 *
 * Quem precisa do prefixo é o link renderizado; a URL absoluta pega o prefixo do
 * `buildSiteBaseUrl`, que já o embute — somar nos dois lugares duplicaria.
 */
export function buildEntryPath({
  listingLink,
  itemSlug,
}: EntryPathParams): string | null {
  const base = normalize(listingLink);
  if (!base) return null;

  const slug = itemSlug?.trim();

  return slug ? `${base}/${slug}` : base;
}

/**
 * URL absoluta do registro, para a propriedade `url` do JSON-LD.
 *
 * Devolve `null` quando falta a configuração do bloco ou a origem do site — a
 * regra é não exibir, nunca chutar um endereço.
 */
export function buildEntryUrl({
  baseUrl,
  listingLink,
  itemSlug,
}: EntryUrlParams): string | null {
  const path = buildEntryPath({ listingLink, itemSlug });
  if (!path || !baseUrl) return null;

  return `${baseUrl}${path}`;
}
